import React, { useEffect, useRef, useState } from "react";
import { motion } from "framer-motion";
import CountAndExperi from "../components/Home/CountAndExp/CountAndExperi.tsx";
import BrandsPage from "../components/Home/BrandPage/BrandsPage.tsx";
import WhyAptech from "../components/Home/WhyAptech/WhyAptech.tsx";
import OurBrands from "../components/Home/OurBrands/OurBrands.tsx";
import CareerSupport from "../components/Home/CareerSupport/CareerSupport.tsx";
import Awards from "../components/Home/Award/Awards.tsx";
import Carousel from "../components/Home/Carousel/Carousel.tsx";
import MetaComponent from "../components/CommonComponents/MetaComponent.tsx";
import GlobalRetail from "../components/Home/GlobalRetail/GlobalRetail.tsx";
import ModernDayLearning from "../components/Home/ModernDayLearning/ModernDayLearning.tsx";
import PartnerWithUs from "../components/Home/PartnerWithUs/PartnerWithUs.tsx";
import OrganizationSchema from "../components/CommonComponents/OrganizationSchema.tsx";

const Home = () => {
  const sections = [
    // { component: <CountAndExperi />, ref: useRef(null) },
    { component: <WhyAptech />, ref: useRef(null) },
    { component: <CareerSupport />, ref: useRef(null) },
    { component: <OurBrands />, ref: useRef(null) },
    { component: <BrandsPage />, ref: useRef(null) },
    { component: <GlobalRetail />, ref: useRef(null) },
    { component: <ModernDayLearning />, ref: useRef(null) },
    { component: <Awards />, ref: useRef(null) },
    { component: <PartnerWithUs />, ref: useRef(null) },
  ];

  const [visibleSections, setVisibleSections] = useState({});

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            setVisibleSections((prev) => ({
              ...prev,
              [entry.target.dataset.section]: true,
            }));
          }
        });
      },
      { threshold: 0.1 }
    );

    sections.forEach(({ ref }, index) => {
      if (ref.current) {
        ref.current.dataset.section = index;
        observer.observe(ref.current);
      }
    });

    return () => observer.disconnect();
  }, []);

  return (
    <>
      <div style={{ overflow: "hidden" }}>
        <MetaComponent
          title="Vocational Training Courses & Skill Development Programs | Aptech Limited"
          desc="Enhance your career with Aptech Limited’s industry-focused vocational training courses and skill development programs designed to build job-ready talent across sectors."
          keywords="vocational training provider, Aptech limited, vocational training programs, skill development training"
        />
        {/* Carousel (Excluded from animation) */}
        <Carousel />
        <CountAndExperi />

        <OrganizationSchema />
        {/* Animated Sections */}
        {sections.map(({ component, ref }, index) => (
          <motion.div
            key={index}
            ref={ref}
            initial={{ opacity: 0, y: 100 }}
            animate={visibleSections[index] ? { opacity: 1, y: 0 } : {}}
            transition={{ duration: 1, ease: "easeInOut" }}
          >
            {component}
          </motion.div>
        ))}
      </div>
    </>
  );
};

export default Home;
